import axios from 'axios';
import { Plant } from 'views/feed-management/features/plants/types/plant.type';
import { CreatePlantInput } from 'views/feed-management/features/plants/types/create-plant-input.type';

// POST
// Add plant.
// /ewosapi/v1/bestmix/plant
export const postFeedManagementPlant = async (request: CreatePlantInput): Promise<Plant> => {
  const res = await axios.post<Plant>(`/ewosapi/v1/bestmix/plant`, request);
  return res.data;
};
